import styled from "@emotion/styled";
import React from "react";
import logo from "src/assets/images/new_logo_white.svg";
import { i18n, mediaQuery, openContactModal, useAppDispatch } from "src/common";
import { ProgressBar, Text } from "src/components";
import config from "src/config";
import { colors, header, headerWidget } from "src/theme";
import { Flex } from "../grid";
// import { HeaderWidgetGiveaway } from "./headerWidget.layout";

const HeaderStyle = styled.div({
  backgroundColor: colors.primary,
  height: `${header.mobileHeight}px`,
  position: 'fixed',
  width: '100%',
  top: 0,
  left: 0,
  zIndex: 100,

  [mediaQuery('laptopL')]: {
    height: `${header.height}px`,
  },
})

// TODO: Add back the widget when we have the new giveaway
// const WidgetStyle = styled(HeaderWidgetGiveaway)({
//   height: `${headerWidget.mobileHeight}px`,

//   [mediaQuery('laptopL')]: {
//     height: `${headerWidget.height}px`,
//   },
// })

const LinkStyle = styled.a({
  cursor: 'pointer',

  '&:hover': {
    opacity: 0.6
  },
})

const LogoStyle = styled.img({
  height: '24px'
})

const TextStyle = styled(Text)({
  color: colors.white
})

const ContainerStyle = styled(Flex)({
  height: `${header.mobileHeight - headerWidget.mobileHeight}px`,
  padding: '24px',

  [mediaQuery('laptopL')]: {
    width: '1150px',
    margin: '0 auto',
    padding: 0,
    height: `${header.height - headerWidget.height}px`,
  },
})

export const Header = () => {
  const dispatch = useAppDispatch();

  const navigateToHome = () => {
    window.location.href = config.REACT_APP_KOMPARE_HOME!;
  };

  return (
    <HeaderStyle>
      {/* <WidgetStyle /> */}
      <ContainerStyle justify='space-between' align='center' gap={8}>
        <LinkStyle onClick={navigateToHome}><LogoStyle src={logo} alt="" /></LinkStyle>
        <LinkStyle onClick={() => dispatch(openContactModal())}>
          <TextStyle type="base" bold>{i18n.t('layout.header.requestAgent')}</TextStyle>
        </LinkStyle>
      </ContainerStyle>
      <ProgressBar />
    </HeaderStyle>
  )
};
